import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class CustomerBookingService {
  constructor(private _HttpClient: HttpClient) {}

  // 1 getServices
  getServices(): Observable<any> {
    return this._HttpClient.get<any>(
      environment.baseUrl + 'shared/get-services'
    );
  }

  // 2 get from services
  getSubService(id: string): Observable<any[]> {
    return this._HttpClient.get<any[]>(
      environment.baseUrl + `shared/get-sub-service/${id}`
    );
  }

  // 3 get from sub services
  getSubServiceWithSub(id: string): Observable<any[]> {
    return this._HttpClient.get<any[]>(
      environment.baseUrl + `customer/get-sub-subservices/${id}`
    );
  }

  // 4 get from sub services from hc
  GetSubServiceByHc(
    hcId: string,
    subId: string,
    branchId?: string
  ): Observable<any[]> {
    let url =
      environment.baseUrl +
      `customer/get-sub-subservices-by-healthcare/${hcId}/${subId}`;

    if (branchId) {
      url += `/${branchId}`;
    }

    return this._HttpClient.get<any[]>(url);
  }

  GetHealthCarePrice(
    serviceId: string,
    healthCareId: string,
    branchId?: string
  ): Observable<any> {
    const params: any = {
      service_id: serviceId,
      health_care_id: healthCareId,
    };

    if (branchId) {
      params.branch_id = branchId;
    }

    return this._HttpClient.get<any>(
      environment.baseUrl + 'customer/get-health-care-price',
      { params }
    );
  }

  createNewBooking(formData: any): Observable<any> {
    return this._HttpClient.post<any>(
      environment.baseUrl + 'admin/create-new-booking',
      formData
    );
  }

  createPublicBooking(formData: any): Observable<any> {
    return this._HttpClient.post<any>(
      environment.baseUrl + 'shared/public-create-booking',
      formData
    );
  }

  sendCode(formData: any): Observable<any> {
    return this._HttpClient.post<any>(
      environment.baseUrl + 'admin/check-offer-code',
      formData
    );
  }

  getExistingUsers(): Observable<any> {
    return this._HttpClient.get<any>(
      environment.baseUrl + 'admin/get-all-existing-users'
    );
  }

  createNewBookingUsers(formData: any): Observable<any> {
    return this._HttpClient.post<any>(
      environment.baseUrl + 'admin/create-new-booking-for-exiting-user',
      formData
    );
  }
}
